import client from "../api/client";
export const getList = () => {
  return client('/api/roles').then(({ data }) => data.data);
};

export const getDetail = (id) => {
  return client(`/api/roles/${id}`).then(({ data }) => data.data);
};

export const addEditModel = (values= {}, id=null) => {
  if (id){
    return client(`/api/roles/${id}`, {method: 'put', body: values}).then(({ data }) => data.data);
  } else {
    return client('/api/roles', {method: 'post', body: values}).then(({ data }) => data.data);
  }
};

export const delModel = (id) => {
    return client(`/api/roles/${id}`, {method: 'delete'}).then(({ data }) => data.data);
};

export function useRoleService () {
  return {
    getList,
    addEditModel,
    getDetail,
    delModel,
  };
}
